import { DraftBadge } from './DraftBadge';

export default DraftBadge;
